import { useContext } from 'react';
import classNames from 'classnames';
import { getBucketEnv } from './util';
import { TenantContext } from '../../context/tenant-context';

export const S3Image = ({
  s3Key,
  className,
  href,
  alt,
  onError = 'show',
}: {
  s3Key: string;
  className?: string;
  href?: string;
  alt?: string;
  onError?: string; // show -> show broken image, hide -> hide broken image, anything else is backup key to use
}) => {
  const { tenant } = useContext(TenantContext);
  const bucketEnv = getBucketEnv(tenant);
  const image = (
    <img
      loading="lazy"
      src={`https://quipli-service-${bucketEnv}-public.s3.amazonaws.com/${tenant}/${s3Key}`}
      className={classNames(className)}
      alt={alt}
      onError={(e) => {
        if (onError === 'show') {
          return;
        } else if (onError === 'hide') {
          e.currentTarget.style.display = 'none';
        } else {
          e.currentTarget.src = `https://quipli-service-${bucketEnv}-public.s3.amazonaws.com/${tenant}/${onError}`;
        }
      }}
    />
  );

  return (
    <>
      {href ? (
        <a href={href} target="_blank" rel="noreferrer">
          {image}
        </a>
      ) : (
        image
      )}
    </>
  );
};
